/**
 * Searching in header class
 */
class SearchingInHeader {
	/**
	 * This runs on load
	 */
	constructor() {
		this.searching = false;
		this.menuSearchClassName = '#main-header .module-search';
		this.menuSearchWrapperName = '#main-header .gt-search-row-mod';
		this.menuBtnName = '#main-header .gt-menu-search-btn';
		this.mobileMenuSearchClassName = '#mobile-menu .module-search';
		this.searchBtn = document.querySelectorAll('#main-header .gt-menu-search-btn, #mobile-menu .module-search button');
	}

	/**
	 * Initialize class
	 *
	 * @return {void}
	 */
	init() {
		document.querySelector(this.mobileMenuSearchClassName).classList.add('gt-searching');
		this.addEventListeners();
	}

	/**
	 * Add event listeners
	 *
	 * @return {void}
	 */
	addEventListeners() {
		if (this.searchBtn) {
			this.searchBtn.forEach((_, i) => {
				this.searchBtn[i].addEventListener('click', this.handlerSearchClick.bind(this));
			});
		}
		document.addEventListener('click', this.outsideClick.bind(this));
	}

	/**
	 * First btn click shows input. 2nd click searches
	 *
	 * @param {Object} el
	 * @return {void}
	 */
	handlerSearchClick(el) {
		const _this = el.target;

		if (this.searching == true && _this.closest(this.menuBtnName).classList.contains('gt-opened')) {
			document.querySelector(this.menuBtnName).classList.remove('gt-opened');
			document.querySelector(this.menuSearchClassName).classList.remove('gt-searching');
			this.searching = !this.searching;
			return;
		}

		if (
			_this.closest(this.mobileMenuSearchClassName) !== null &&
			_this.closest(this.mobileMenuSearchClassName).classList.contains('gt-searching')
		) {
			this.searching = true;
		}

		if (this.searching == false) {
			el.preventDefault();
			_this.closest(this.menuBtnName).classList.add('gt-opened');
			_this.closest(this.menuSearchWrapperName).querySelector('.module-search').classList.add('gt-searching');
			setTimeout(() => {
				_this.closest(this.menuSearchWrapperName).querySelector('.module-search').querySelector('input').focus();
			}, 50);
			this.searching = !this.searching;
		} else if (
			_this.closest(this.menuSearchWrapperName).querySelector('form').querySelector('input').value.length < 1
		) {
			el.preventDefault();
		}
	}

	/**
	 * Hide input on outsideclick on desktop
	 *
	 * @param {Object} el
	 * @return {void}
	 */
	outsideClick(el) {
		const _this = el.target;

		if (this.searching == true && _this.closest(this.menuSearchWrapperName) === null) {
			document.querySelector(this.menuBtnName).classList.remove('gt-opened');
			document.querySelector(this.menuSearchClassName).classList.remove('gt-searching');
			this.searching = !this.searching;
		}
	}
}

// Check if module exist before class runs
if (document.querySelector('#header .module-search')) {
	document.addEventListener('DOMContentLoaded', () => {
		const searchingInHeader = new SearchingInHeader();
		searchingInHeader.init();
	});
}
